import { authRoutes } from '@xstudios/xapp-auth/routes'
import { isTokenExpired } from '@xstudios/xapp-auth/services/authService'
import { useRuntimeAuthStore } from '@xstudios/xapp-auth/stores/runtimeAuthStore'
import { NotFoundPage } from '@xstudios/xapp-core/pages'
import { BrokerPage } from '@xstudios/xapp-core/pages'
import { createRouter, createWebHistory } from 'vue-router'

// import { adminRoutes } from '@/domains/admin/routes'
import { deviceRoutes } from '@/domains/device/routes'
import { tagRoutes } from '@/domains/tags/routes'

const appRoutes = [
  {
    // component: () => import('@/pages/index.vue'),
    component: () => import('@/pages/admin.vue'),
    meta: { requiresAuth: true },
    name: 'dashboard',
    path: '/',
  },
  // {
  //   component: () => import('@/pages/admin.vue'),
  //   meta: { requiresAuth: true },
  //   name: 'admin',
  //   path: '/admin',
  // },
  {
    component: BrokerPage,
    meta: { requiresAuth: true },
    name: 'broker',
    path: '/broker',
  },
  // {
  //   component: () => import('@/pages/users.vue'),
  //   meta: { requiresAuth: true },
  //   name: 'users',
  //   path: '/users',
  // },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_ROUTE_BASE || '/'),
  routes: [
    ...appRoutes,
    ...authRoutes,
    ...deviceRoutes,
    ...tagRoutes,
    // ...adminRoutes,
    {
      component: NotFoundPage,
      meta: { layout: false, requiresAuth: false },
      name: 'not-found',
      path: '/:pathMatch(.*)*',
    },
  ],
})

router.beforeEach(async (to, _from) => {
  const authStore = useRuntimeAuthStore()
  if (!authStore.bootstrapped) {
    await authStore.bootstrap()
  }

  // Default: require auth unless route is /login or /not-found
  const publicPaths = ['/login', '/not-found']
  const requiresAuth =
    to.meta.requiresAuth === undefined
      ? !publicPaths.includes(to.path)
      : to.meta.requiresAuth

  const hasToken = !!String(authStore.token || '').trim()
  const hasValidAuth = hasToken
    ? !isTokenExpired(authStore.token)
    : !!authStore.authenticated

  if (authStore.authenticated && !hasValidAuth) {
    authStore.clearSession()
  }

  if (requiresAuth && !hasValidAuth) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    }
  }

  if (requiresAuth) {
    const requiredPerm = to.meta?.perm
    const requiredAllPerm = to.meta?.allPerm
    const requiredAnyPerm = (
      to.meta?.anyPerm ??
      to.meta?.permissions ??
      []
    ).filter(Boolean)

    const lacksPerm = requiredPerm && !authStore.can(requiredPerm)
    const lacksAllPerm =
      Array.isArray(requiredAllPerm) && !authStore.canAll(requiredAllPerm)
    const lacksAnyPerm =
      Array.isArray(requiredAnyPerm) &&
      requiredAnyPerm.length > 0 &&
      !authStore.canAny(requiredAnyPerm)

    if (lacksPerm || lacksAllPerm || lacksAnyPerm) {
      return { path: '/' }
    }
  }
})

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (localStorage.getItem('vuetify:dynamic-reload')) {
      console.error('Dynamic import error, reloading page did not fix it', err)
    } else {
      console.log('Reloading page to fix dynamic import error')
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    }
  } else {
    console.error(err)
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

export default router
